// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,700;1,400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,700;1,400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-start-4 {
  inset-inline-start: -1rem;
}
.left-0 {
  left: 0px;
}
.right-0 {
  right: 0px;
}
.top-10 {
  top: 2.5rem;
}
.top-12 {
  top: 3rem;
}
.top-\\[-4\\.5rem\\] {
  top: -4.5rem;
}
.z-10 {
  z-index: 10;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[1\\] {
  z-index: 1;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.float-right {
  float: right;
}
.m-2 {
  margin: 0.5rem;
}
.m-\\[10px\\] {
  margin: 10px;
}
.m-\\[20px\\] {
  margin: 20px;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.-my-2 {
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
}
.mx-8 {
  margin-left: 2rem;
  margin-right: 2rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[10px\\] {
  margin-bottom: 10px;
}
.mb-\\[11px\\] {
  margin-bottom: 11px;
}
.mb-\\[20px\\] {
  margin-bottom: 20px;
}
.mb-\\[40px\\] {
  margin-bottom: 40px;
}
.mb-\\[5rem\\] {
  margin-bottom: 5rem;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-8 {
  margin-left: 2rem;
}
.ml-\\[10px\\] {
  margin-left: 10px;
}
.ml-\\[20px\\] {
  margin-left: 20px;
}
.ml-\\[24px\\] {
  margin-left: 24px;
}
.ml-\\[40px\\] {
  margin-left: 40px;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-\\[10px\\] {
  margin-right: 10px;
}
.mr-\\[14px\\] {
  margin-right: 14px;
}
.mr-\\[16px\\] {
  margin-right: 16px;
}
.mr-\\[24px\\] {
  margin-right: 24px;
}
.ms-6 {
  margin-inline-start: 1.5rem;
}
.ms-8 {
  margin-inline-start: 2rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[-22px\\] {
  margin-top: -22px;
}
.mt-\\[-35px\\] {
  margin-top: -35px;
}
.mt-\\[-5px\\] {
  margin-top: -5px;
}
.mt-\\[20px\\] {
  margin-top: 20px;
}
.mt-\\[30px\\] {
  margin-top: 30px;
}
.mt-\\[36px\\] {
  margin-top: 36px;
}
.mt-\\[40px\\] {
  margin-top: 40px;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[3\\/2\\] {
  aspect-ratio: 3/2;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-2 {
  height: 0.5rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-3\\/4 {
  height: 75%;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[1\\.0rem\\] {
  height: 1.0rem;
}
.h-\\[16px\\] {
  height: 16px;
}
.h-\\[17px\\] {
  height: 17px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[250px\\] {
  height: 250px;
}
.h-\\[418px\\] {
  height: 418px;
}
.h-\\[60vh\\] {
  height: 60vh;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10\\/12 {
  width: 83.333333%;
}
.w-12 {
  width: 3rem;
}
.w-2 {
  width: 0.5rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/12 {
  width: 41.666667%;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[1\\.3rem\\] {
  width: 1.3rem;
}
.w-\\[1\\.5rem\\] {
  width: 1.5rem;
}
.w-\\[16px\\] {
  width: 16px;
}
.w-\\[17px\\] {
  width: 17px;
}
.w-\\[1em\\] {
  width: 1em;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[330px\\] {
  width: 330px;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[500px\\] {
  width: 500px;
}
.w-\\[65\\.666rem\\] {
  width: 65.666rem;
}
.w-\\[676px\\] {
  width: 676px;
}
.w-\\[7\\.5rem\\] {
  width: 7.5rem;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[82\\%\\] {
  width: 82%;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.min-w-min {
  min-width: min-content;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.table-auto {
  table-layout: auto;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.list-inside {
  list-style-position: inside;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-layout {
  grid-template-columns: 250px 1fr;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-11 {
  gap: 2.75rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity));
}
.divide-gray-300 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-divide-opacity));
}
.self-center {
  align-self: center;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[24px\\] {
  border-radius: 24px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-b {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-l-\\[20px\\] {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.rounded-r-\\[20px\\] {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-s {
  border-inline-start-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-\\[\\#008F31\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 143 49 / var(--tw-border-opacity));
}
.border-\\[\\#A30808\\] {
  --tw-border-opacity: 1;
  border-color: rgb(163 8 8 / var(--tw-border-opacity));
}
.border-\\[\\#DADADA\\] {
  --tw-border-opacity: 1;
  border-color: rgb(218 218 218 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
.border-green-400 {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}
.border-l-\\[\\#fff\\] {
  --tw-border-opacity: 1;
  border-left-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-r-\\[\\#fff\\] {
  --tw-border-opacity: 1;
  border-right-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-t-\\[\\#fff\\] {
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.bg-\\[\\#005FF9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 95 249 / var(--tw-bg-opacity));
}
.bg-\\[\\#80808091\\] {
  background-color: #80808091;
}
.bg-\\[\\#C7F6E2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(199 246 226 / var(--tw-bg-opacity));
}
.bg-\\[\\#ECECEC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(236 236 236 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFABAB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 171 171 / var(--tw-bg-opacity));
}
.bg-\\[\\#f9fafb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(2 27 65 / var(--tw-bg-opacity));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.fill-current {
  fill: currentColor;
}
.object-cover {
  object-fit: cover;
}
.p-1 {
  padding: 0.25rem;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[0\\.7rem\\] {
  padding: 0.7rem;
}
.p-\\[10px\\] {
  padding: 10px;
}
.p-\\[6px\\] {
  padding: 6px;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[22px\\] {
  padding-top: 22px;
  padding-bottom: 22px;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[30px\\] {
  padding-bottom: 30px;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pl-\\[70px\\] {
  padding-left: 70px;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-\\[100px\\] {
  padding-right: 100px;
}
.pr-\\[10px\\] {
  padding-right: 10px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-\\[2\\.5rem\\] {
  padding-top: 2.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-middle {
  vertical-align: middle;
}
.font-\\[\\'Montserrat\\'\\] {
  font-family: 'Montserrat';
}
.font-\\[Inter\\] {
  font-family: Inter;
}
.font-\\[Montserrat\\] {
  font-family: Montserrat;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[0\\.875rem\\] {
  font-size: 0.875rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13\\.22px\\] {
  font-size: 13.22px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[18\\.2px\\] {
  font-size: 18.2px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[1rem\\] {
  font-size: 1rem;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22\\.663px\\] {
  font-size: 22.663px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[400\\] {
  font-weight: 400;
}
.font-\\[600\\] {
  font-weight: 600;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.not-italic {
  font-style: normal;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-9 {
  line-height: 2.25rem;
}
.leading-\\[0\\.7px\\] {
  line-height: 0.7px;
}
.leading-\\[150\\%\\] {
  line-height: 150%;
}
.leading-\\[17\\.942px\\] {
  line-height: 17.942px;
}
.leading-\\[19\\.5px\\] {
  line-height: 19.5px;
}
.leading-\\[19px\\] {
  line-height: 19px;
}
.leading-\\[22px\\] {
  line-height: 22px;
}
.leading-\\[27px\\] {
  line-height: 27px;
}
.leading-\\[31\\.162px\\] {
  line-height: 31.162px;
}
.leading-\\[normal\\] {
  line-height: normal;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-tight {
  line-height: 1.25;
}
.text-\\[\\#00000080\\] {
  color: #00000080;
}
.text-\\[\\#00000099\\] {
  color: #00000099;
}
.text-\\[\\#0000\\] {
  color: #0000;
}
.text-\\[\\#000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#005FF9\\] {
  --tw-text-opacity: 1;
  color: rgb(0 95 249 / var(--tw-text-opacity));
}
.text-\\[\\#007AFF\\] {
  --tw-text-opacity: 1;
  color: rgb(0 122 255 / var(--tw-text-opacity));
}
.text-\\[\\#101828\\] {
  --tw-text-opacity: 1;
  color: rgb(16 24 40 / var(--tw-text-opacity));
}
.text-\\[\\#111827\\] {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-\\[\\#121212\\] {
  --tw-text-opacity: 1;
  color: rgb(18 18 18 / var(--tw-text-opacity));
}
.text-\\[\\#237253\\] {
  --tw-text-opacity: 1;
  color: rgb(35 114 83 / var(--tw-text-opacity));
}
.text-\\[\\#344054\\] {
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity));
}
.text-\\[\\#424242\\] {
  --tw-text-opacity: 1;
  color: rgb(66 66 66 / var(--tw-text-opacity));
}
.text-\\[\\#475467\\] {
  --tw-text-opacity: 1;
  color: rgb(71 84 103 / var(--tw-text-opacity));
}
.text-\\[\\#5BDB1F\\] {
  --tw-text-opacity: 1;
  color: rgb(91 219 31 / var(--tw-text-opacity));
}
.text-\\[\\#A30808\\] {
  --tw-text-opacity: 1;
  color: rgb(163 8 8 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.opacity-25 {
  opacity: 0.25;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_3px_6px_0px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
  --tw-shadow: 0px 3px 6px 0px rgba(0,0,0,0.08);
  --tw-shadow-colored: 0px 3px 6px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.ease-linear {
  transition-timing-function: linear;
}

body {
  margin: 0;  
  font-family: Montserrat;
  font-style: normal;
}

code {
  font-family: Montserrat;
}

.link-active{
  border: 4px solid #fff;
  border-inline-start-color:rgba(0, 95, 249, 1);
  border-inline-start-width: 6px;
  color: #111312;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px; 
}

.link-border{
  border: 4px solid #fff;
  border-inline-start-color: #fff;
  border-inline-start-width: 6px;
}

.link-border:hover{
  color: #111312;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px; /* 135.714% */
}

.nav-bord{
  box-shadow: 0 4px 16px 0 rgba(0,0,0,0.2);
}

.subNavClose{
  overflow: hidden;
  max-height: 0px;
  transition: max-height 0.3s ease-out;
}

.subNavOpen{
  overflow: hidden;
  height: auto;
  transition: max-height 0.3s ease-in;
}

.m30{
  margin-bottom: 30px;
}

.ml32{
  margin-left: 50px;
}

.logo-login {
  width: 121.966px;
  height: 60.131px;
  flex-shrink: 0;
}

.logo-Nav {
  width: 100%;
  height: 80px;
  padding-left: 20px;
}

.color-a{
  color: rgba(75, 133, 227, 0.4);
}

.color-Logout{
  color: #005FF9;
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 137.5% */
}

.fontPageTitle{
  font-family: Montserrat;
  font-weight: 700;
}

.fontPageTitle600{
  font-family: Montserrat;
  font-weight: 600;
}

.font-size-22{
  font-size: 22.66px;
}

.font-size-12{
  font-size: 12px;
}

.home-title-tap {
  width: 9.5rem;
  font-size: 16px;
  line-height: 19px;
  padding: 10px;
  margin: 10px 0 26px 0px;
}

.tap-actve{
  border-bottom: 4px solid rgba(0, 95, 249, 1);
}

.h-logout{
  height: 49%
}

.h-logout > a > div{
  height: 100%
}

.card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  margin: 10px;
  border-radius: 10px;
}

.card-text-title-1322-400{
  color: #111312;
  font-family: Montserrat;
  font-size: 13.22px;
  font-style: normal;
  font-weight: 400;
  line-height: 17.942px; /* 135.714% */
}

.card-text-footer-1322-400{
  color: #AAA;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px; /* 158.333% */
}

.card-color-1{
  background: rgba(217, 243, 255, 1);
}

.card-background-icon-degradation{
  background: linear-gradient(50.6deg, rgba(0, 95, 249, 0.1) 2.95%, rgba(179, 99, 254, 0.1) 46.88%, rgba(143, 219, 255, 0.1) 97.72%);
}

.card-color-icon-degradation{
  mix-blend-mode: color-burn;
  background: linear-gradient(50.6deg, #005FF9 2.95%, #B363FE 46.88%, #8FDBFF 97.72%), linear-gradient(0deg, #FFFFFF, #FFFFFF);
  color: #000;
  opacity: 0.5;
  border-radius: 20px;
}

.card-color-2{
  background: rgba(246, 240, 255, 1);
}

.card-body{
  padding: 16px 10px 10px 10px;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}

.card-footer {
  padding: 4px;
}

.badge {
  padding: 5px 20px 5px 20px;
  text-align: center;
  border-radius: 50px;
}

.bg-color-cancelled{
  background: #FFABAB;
  color: rgba(254, 44, 44, 0.80);
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.bg-color-error{
  background: #FFABAB;
  color: #A30808;
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.bg-color-failed{
  background: #FFABAB;
  color: #A30808;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.bg-color-rejected{
  background: #FFABAB;
  color: #A30808;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.bg-color-completed{
  background: rgba(6, 118, 71, 0.10);
  color: #067647;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.56px;
}

.bg-color-aproved{
  background: #C7F6E2;
  color: #237253;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.56px;
}

.bg-color-approved{
  background: #C7F6E2;
  color: #237253;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.56px;
}

.bg-color-active{
  background: #C7F6E2;
  color: #237253;
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.56px;
}

.bg-color-pending{
  background: #ECECEC;
  color: #424242;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.bg-color-processed{
  background: rgba(6, 118, 71, 0.10);
  color: #067647;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.bg-color-expired{
  background: #FFD8AB;
  color: #E59500;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.btn-active{
  background: #005FF9;
  color: #fff;
}

.icon-blue{
  color: #005FF9;
}

.btn-disabled {
  background: #005ff99e;
  color: #fff;
}

.btn-inactive{
  background: #EDEDED;
  
}

.btn-i{
  padding: 2px 12px 2px 12px;
  border-radius: 17px;
  width: 4.5rem;
  height: 36px;
}

.section-filters{
  width: 94%;
  margin: 0 0 0 24px;
}

.active{
  background: #B363FE;
  color: #fff;
}

.page-item{
  padding: 4px 12px 4px 12px;
  border-radius: 5px;
  border: 1px solid #D0D5DD;
  margin: 20px 2px 0 2px;
}

.page-item-1{
  padding: 4px 12px 4px 12px;
  border-radius: 5px;
  margin: 20px 2px 0 2px;
}

.pages-lat{
  margin: 25px 2px 0 2px;
  padding: 4px 12px 4px 12px;
}

.text-w-rigth{
  text-align: -webkit-right;
}

.input-search{
  border: 1px solid #DADADA;
  padding: 12px 0px 12px 24px;
  border-radius: 24px;
}

.input-search:focus{
  outline: none;
  border: 1px solid #DADADA;
}

.input-text{
  border: 1px solid #DADADA;
  border-radius: 4px;
}

.input-text:focus{
  outline: none;
  border: 1px solid #DADADA;
}

.bg-bages-green{
  background: #008000;
  color: #fff;
}

.btn-alert-modal{
  background: linear-gradient(0deg, #DADADA, #DADADA),
  linear-gradient(0deg, #FFFFFF, #FFFFFF);  
  border: 1px solid rgba(218, 218, 218, 1);
  box-shadow: 0px 1px 2px 0px #0000000D;

}

.color-alert{
  color: #E00748;
}

.btn-report{
  border-radius: 42px;
  border: 1px solid #DADADA;
  background: #FFF;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.08);
  display: inline-flex;
  height: 40px;
  padding: 12px 20px;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  color: #E00748;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 183.333% */ 
}

.color-alert-report{
  color: #FF0000;
  border: 1px solid #FF0000;
  border-radius: 24px;
  box-shadow: 0px 1px 2px 0px #0000000D;

}

.color-black{
  color: #000;

}

.color-card-footer{
  color: #AAAAAA;
}

.btn-downl{
  padding: 8px 12px 8px 12px;
  border-radius: 39px;
  gap: 8px;
  
}

.card-bages{
  padding: 2px 8px 2px 8px;
}

.input-select{
  width: 154px;
  height: 40px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #DADADA;

}

.snackbar {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 24px;
  border-radius: 4px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
}

.snackbar.show {
  opacity: 1;
  visibility: visible;
}

.alert-error-snackbar{
  background-color: rgb(238, 68, 68);
  color: #FFFFFF;
}

.pages-title-t {
  color: #111312;
  font-family: 'Montserrat', sans-serif;;
  
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px; 
}

.cargGen-amount{
  color: #111312;
  font-family: Montserrat;
  font-size: 22.663px;
  font-style: normal;
  font-weight: 700;
  line-height: 31.162px; 
}

#table-content > thead > tr > th {

}

#table-content > tbody > tr > td {
  color: #111312;
  font-family: Montserrat;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 19.853px; /* 124.079% */
}

#table-content-2 > thead > tr > th {

}

.header-user{
  color: #005FF9 !important;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px; /* 135.714% */
}

.login-welcome{
  color: var(--black, #000);
  text-align: center;
  font-family: Montserrat;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 57.6px */
}

.login-welcome-sub{
  color: var(--black, #000);
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
}

.login-section-img{
  position: absolute;
  top: 20px;
}

.login-input{
  border-radius: 24px;
  background: #FFF;
  box-shadow: 1px 3px 10px 0px rgba(68, 68, 68, 0.17);
}
.login-input:focus-visible {
  border: 1px solid #005FF9;
  outline: none;
}

.login-laabel-pass{
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  cursor: pointer;
}

.login-Label{
  color: var(--black, #000);
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
}

.login-btn-text{
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
}

.login-sign-in-btn{
  color: #005FF9;
  border-radius: 40px;
  border: 1px solid #005FF9;
}

.border-col {
  border: 1px solid #DADADA;
}

.errors-msm{
  color: #F00;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
}

.errors-input{
  border: 1px solid #F00;
  color: #F00;
}

.errors-input:focus-visible {
  border: 1px solid #F00;
  color: #F00;
  outline: none;
}

#default-search:focus-visible {
  border: 1px solid #FFF;
  color: #000;
  outline: none;
}

.errors-input:focus{
  border: 1px solid #F00;
  color: #F00;
}

.login-changePass{
  border-radius: 12px;
  background: #C3FFC6;
  padding: 16px 24px;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

.text-12{
  color: #666766;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 183.333% */
}

.text-12-not-bold{
  color: #111312;
  font-family: Montserrat;
  /* font-size: 12px; */
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 183.333% */
}

.text-16{
  color: #000;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 27px; /* 168.75% */
}

.text-16-lh-normal{
  color: #000;
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.text-13-500{
  color: rgba(0, 0, 0, 0.60);
  text-align: center;
  font-family: Montserrat;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.text-15-500{
  color: rgba(0, 0, 0, 0.40);
  font-family: Montserrat;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px; /* 126.667% */
}

.text-16-400{
  color: var(--black, #000);
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
}

.text-16-500{
  color: var(--black, #000);
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
}

.text-16-700{
  color: rgba(0, 0, 0, 0.50);
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 137.5% */
}

.text-16-700-111312{
  color: #111312;
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 137.5% */
}

.text-17-700{
  color: #000;
  font-family: Montserrat;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: 27px; /* 158.824% */
}

.text-17-500{
  color: rgba(0, 0, 0, 0.40);
  font-family: Montserrat;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.408px;
}

.text-17-500-000{
  color: #000;
  font-family: Montserrat;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.408px;
}

.text-20-700{
  color: #000;
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 27px; /* 135% */
}

.text-14{
  color: #666766;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 157.143% */
}

.text-14-lh20{
  color: #666766;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 157.143% */
}


.text-14-111312-700{
  color: #111312;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 157.143% */ 
}

.text-14-500{
  color: #666766;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
}

.text-14-500-000{
  color: #000;
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
}

.text-14-400-000{
  color: #111312;
  text-align: center;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 183.333% */
}

.text-14-600{
  color: #666766;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}

.text-18-500{
  color: #111312;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px; /* 105.556% */
}

.text-18-600{
  color: #000;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 19px; /* 105.556% */
}

.text-12634-700{
  color: #949494;
  text-align: center;
  font-family: Montserrat;
  font-size: 12.634px;
  font-style: normal;
  font-weight: 700;
  line-height: 18.048px; /* 142.857% */
}

.text-max-center{
  text-align: -moz-center !important;
}

.text-left-impot{
  text-align: left !important;
}
.table-info{
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: #fff #fff;
}
.table-info::-webkit-scrollbar {
  width: 6px;
}
.table-info::-webkit-scrollbar-track {
  background-color: #fff;
}
 .table-info::-webkit-scrollbar-thumb:hover {
  background: #ededed7d
} 

.table-info-role{
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #fff #F9F9FC;
}
.table-info-role::-webkit-scrollbar {
  width: 6px;
}
.table-info-role::-webkit-scrollbar-track {
  background-color: #ededed7d;
}
 .table-info-role::-webkit-scrollbar-thumb:hover {
  background: #f0f0f0
} 

.nav-content{
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #fff #fff;
}
.nav-content::-webkit-scrollbar {
  width: 6px;
}
.nav-content::-webkit-scrollbar-track {
  background-color: #fff;
}
 .nav-content::-webkit-scrollbar-thumb:hover {
  background: #f0f0f0
} 

::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background-color: #fff;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background-color: #f0f0f0;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #00000048
}

.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 220px;
  background-color: #fff;
  color: #000;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -60px;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 25%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #08080854 transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}


.input-otp{
  width: 46px !important;
  height: 48px !important;
  padding: 10px 14px;
  align-items: center;
  gap: 8px;
  border-radius: 7px;
  background: #FFF;
  box-shadow: 1px 3px 10px 0px rgba(68, 68, 68, 0.17);
  margin-right: 4px;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn-upload {
  display: flex;
  width: 184px;
  padding: 14px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 40px;
  border: 1px solid #007AFF;
  color: #007AFF;
  text-align: center;
  font-feature-settings: 'case' on;
  font-family: Montserrat;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.408px;
}

.bord-th-body-table {
  border-bottom: 1px solid #EAECF0;
  padding: 9px 0px;
}

.border-fff{
  border: 1px solid #fff !important;
}

.btn-upload-submit {
  display: flex;
  width: 184px;
  padding: 14px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 7px;
  border: 1px solid #007AFF;
  color: #fff;
  background: #007AFF;
  text-align: center;
  font-feature-settings: 'case' on;
  font-family: Montserrat;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.408px;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.file-selected{
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 43px;
  background: #D4FFD9;
}

.border-input {
  border-radius: 20px;
  border: 1px solid var(--gray-300, #D0D5DD);
  background: var(--white, #FFF);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.border-input-fff {
  border-radius: 20px;
  border: 1px solid #FFF;
  background: var(--white, #FFF);
  box-shadow: 0px 1px 2px 0px #FFF;
}

.table-tr-body{
  border-radius: 20px !important;
}

.table-td-content{
  background: #FFF;
 /*  height: 110px;  */
}

.table-border-head{
  border-bottom: 1px solid #DADADA;
}

.statue-md{
  border-radius: 20px;
  border: 4px solid var(--gray-300, #D0D5DD47);
  background: var(--white, #FFF);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.p-none{
  display: none;
}

.profile-active{
  border-radius: 4px;
  border: 1px solid #005FF9;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  position: absolute;
  background-color: #fff;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  margin-top: 14px;
}

.dropdown-container-div{
  padding: 10px 14px; 
}

.dropdown-option-color:hover{
  background: #F9F9FC; 
}

.dropdown-active{
  background: #F9F9FC; 
}

.dropdown:hover .dropdown-content {
  /* display: block; */
}

.dropdown-text-option{
  color: var(--gray-900, #101828);
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
}


.color-date-000{
  color: #000 !important;
  background: #D0D5DD47 !important;
  margin: 2px !important;
  border-radius: 8px !important; 
}

.color-date-949494{
  color: #b9b7b7 !important;
}

.color-date-selected-fff{
  color: #fff !important;
  background: #005FF9 !important;
}

.bg-dateClean{
  padding: 8px 16px !important;
  background: #fff !important;
  color: #005FF9 !important;
  font-family: Montserrat !important;
  font-style: normal !important;
  font-weight: 500 !important;
  border: 1px solid #005FF9 !important;
}

.bg-today{
  padding: 8px 16px !important; 
  background: #005FF9 !important;
  color: #fff !important;
  font-family: Montserrat !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important; 
}

.text-start-import{
  text-align: start !important;
}

.alert-success{
  border-left: 8px solid #5BDB1F;
  border-top: 1px solid #5BDB1F;
  border-bottom: 1px solid #5BDB1F;
  border-right: 1px solid #5BDB1F;
  background: #F1FFF5;
}

.p-transaction{
  padding: 10px 0px 0px 20px;
}

.btn-sanddbox{
  position: relative;
    top: -25px;
  border-radius: 20px;
  background: #005FF9;
  padding: 4px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: #FFF;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px; /* 135.714% */
}

.b-top{
  border-top: solid #DADADA;
  padding-left: 36px;
  padding-top: 10px;
}

.bg-status-approved{
  background-color: #18B8B8;
  border-color: #18B8B8
}

.bg-status-pending{
  background-color: #E9BB1A;
  border-color:#E9BB1A ;
}

.bg-status-failed{
  background-color: #A30808;
  border-color: #A30808;
}

.border-status-approved{
  border-color: #18B8B8
}

.border-status-pending{
  border-color:#E9BB1A ;
}

.border-status-failed{
  border-color: #A30808;
}

.text-status-approved{
  color: #18B8B8
}

.text-status-pending{
  color:#E9BB1A ;
}

.text-status-failed{
  color: #A30808;
}

.css-wmw4vi-ReactDropdownSelect {
  box-sizing: border-box;
  position: relative;
  display: flex;
  border: 1px solid #fff !important; 
  width: 100%;
  border-radius: 2px;
  padding: 0px 0px !important;
  flex-direction: row;
  direction: ltr;
  align-items: center;
  cursor: pointer;
  min-height: 36px;
  pointer-events: all;
}

.css-wmw4vi-ReactDropdownSelect:focus, 
.css-wmw4vi-ReactDropdownSelect:focus-within {
  outline: 0;
  box-shadow: 0 0 0 3px rgb(252, 252, 253) !important;
}

@media screen and (min-width: 1200px) {
  /* Estilos para la resolución de pantalla de 1440px o más */
/*   body{
    background-color: black;
  } */
}

@media screen and (max-width: 1109px) {
  /* Estilos para la resolución de pantalla de 1440px o más */
/*    body{
    background-color: #fff;
  } 
  .grid-cols-layout-sm{
    grid-template-columns: 30px 1fr;
  }
  
  .grid-cols-layout-md{
    grid-template-columns: 50px 1fr;
  }
  
  .link-action-mq{
    display: none;
  }

  .ml-mq-0{
    margin-left: 0px;
  } */

}

@media screen and (max-width: 992px) {
  /* Estilos para la resolución de pantalla de 1440px o más */
/*   body{
    background-color: yellow;
  } */
}

@media screen and (max-width: 840px) {
  /* Estilos para la resolución de pantalla de 840px o más */
  .login-res{
    display: none;
  }

/*   body{
    background-color: red;
  } */
}

.first-letter\\:flex::first-letter {
  display: flex;
}

.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}

.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}

.focus\\:border-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}

.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}

.focus\\:ring-gray-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity));
}

.group:hover .group-hover\\:text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

@media (min-width: 640px) {

  .sm\\:-mx-6 {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:w-\\[82\\%\\] {
    width: 82%;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:pl-6 {
    padding-left: 1.5rem;
  }

  .sm\\:pr-6 {
    padding-right: 1.5rem;
  }
}

@media (min-width: 768px) {

  .md\\:w-\\[10\\%\\] {
    width: 10%;
  }

  .md\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .md\\:w-\\[50\\%\\] {
    width: 50%;
  }

  .md\\:w-\\[54\\%\\] {
    width: 54%;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:pl-0 {
    padding-left: 0px;
  }

  .md\\:pr-0 {
    padding-right: 0px;
  }
}

@media (min-width: 1024px) {

  .lg\\:-mx-8 {
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:w-full {
    width: 100%;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

@media (prefers-color-scheme: dark) {

  .dark\\:border-\\[\\#005ff9\\] {
    --tw-border-opacity: 1;
    border-color: rgb(0 95 249 / var(--tw-border-opacity));
  }

  .dark\\:border-gray-600 {
    --tw-border-opacity: 1;
    border-color: rgb(75 85 99 / var(--tw-border-opacity));
  }

  .dark\\:bg-\\[\\#005ff9\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(0 95 249 / var(--tw-bg-opacity));
  }

  .dark\\:bg-blue-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity));
  }

  .dark\\:bg-gray-700 {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity));
  }

  .dark\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }

  .dark\\:text-blue-500 {
    --tw-text-opacity: 1;
    color: rgb(59 130 246 / var(--tw-text-opacity));
  }

  .dark\\:text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
  }

  .dark\\:text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }

  .dark\\:placeholder-gray-400::placeholder {
    --tw-placeholder-opacity: 1;
    color: rgb(156 163 175 / var(--tw-placeholder-opacity));
  }

  .dark\\:ring-offset-gray-800 {
    --tw-ring-offset-color: #1f2937;
  }

  .dark\\:hover\\:bg-blue-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(29 78 216 / var(--tw-bg-opacity));
  }

  .dark\\:hover\\:bg-gray-600:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(75 85 99 / var(--tw-bg-opacity));
  }

  .dark\\:hover\\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }

  .dark\\:focus\\:border-blue-500:focus {
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity));
  }

  .dark\\:focus\\:ring-blue-500:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
  }

  .dark\\:focus\\:ring-blue-600:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(37 99 235 / var(--tw-ring-opacity));
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAQnB;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB,EAAE,aAAa;AACtC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kIAAkI;AACpI;;AAEA;EACE,0BAA0B;EAC1B,4HAA4H;EAC5H,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;;AAErB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;yCACuC;EACvC,wCAAwC;EACxC,qCAAqC;;AAEvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;;AAEvC;;AAEA;EACE,WAAW;;AAEb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,QAAQ;;AAEV;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;;AAE3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qCAAqC;;EAErC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;AAEA;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB,EAAE,aAAa;AACtC;;AAEA;;AAEA;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mDAAmD;AACrD;AACA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;;AAGA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB,EAAE,aAAa;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;CACC;EACC;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;CACC;EACC;AACF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;CACC;EACC;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,mDAAmD;EACnD,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;CACjB,qBAAqB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,4CAA4C;EAC5C,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;;AAGA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,kCAAkC;EAClC,6BAA6B;EAC7B,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,sBAAsB;EACtB,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;IAChB,UAAU;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAIlB,aAAa;EACb,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAG3B,mBAAmB;EACnB,cAAc;EAId,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,2DAA2D;AAC7D;;KAEK;AACL;;AAEA;EACE,2DAA2D;AAC7D;;;;;;;;;;;;;;;;;KAiBK;;AAEL;;AAEA;EACE,2DAA2D;AAC7D;;KAEK;AACL;;AAEA;EACE,0DAA0D;EAC1D;IACE,aAAa;EACf;;AAEF;;KAEK;AACL;;AAp0CA;EAAA;AAo0CC;;AAp0CD;EAAA,kBAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,kBAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,kBAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,oBAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,sBAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,sBAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,kBAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,8BAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,2GAo0CC;EAp0CD,yGAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,2GAo0CC;EAp0CD,yGAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,oBAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,oBAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,oBAo0CC;EAp0CD;AAo0CC;;AAp0CD;EAAA,oBAo0CC;EAp0CD;AAo0CC;;AAp0CD;;EAAA;IAAA,oBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA,oBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;AAAA;;AAp0CD;;EAAA;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA,oBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;AAAA;;AAp0CD;;EAAA;IAAA,kBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA,kBAo0CC;IAp0CD;EAo0CC;AAAA;;AAp0CD;;EAAA;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA;EAo0CC;AAAA;;AAp0CD;;EAAA;IAAA,sBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,sBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,kBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,kBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,kBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,kBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,oBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,oBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,oBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,2BAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA;EAo0CC;;EAp0CD;IAAA,kBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,kBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,oBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,sBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,oBAo0CC;IAp0CD;EAo0CC;;EAp0CD;IAAA,oBAo0CC;IAp0CD;EAo0CC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,700;1,400&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,700;1,400&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap');\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:wght@700&display=swap\");\n\nbody {\n  margin: 0;  \n  font-family: Montserrat;\n  font-style: normal;\n}\n\ncode {\n  font-family: Montserrat;\n}\n\n.link-active{\n  border: 4px solid #fff;\n  border-inline-start-color:rgba(0, 95, 249, 1);\n  border-inline-start-width: 6px;\n  color: #111312;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px; \n}\n\n.link-border{\n  border: 4px solid #fff;\n  border-inline-start-color: #fff;\n  border-inline-start-width: 6px;\n}\n\n.link-border:hover{\n  color: #111312;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px; /* 135.714% */\n}\n\n.nav-bord{\n  box-shadow: 0 4px 16px 0 rgba(0,0,0,0.2);\n}\n\n.subNavClose{\n  overflow: hidden;\n  max-height: 0px;\n  transition: max-height 0.3s ease-out;\n}\n\n.subNavOpen{\n  overflow: hidden;\n  height: auto;\n  transition: max-height 0.3s ease-in;\n}\n\n.m30{\n  margin-bottom: 30px;\n}\n\n.ml32{\n  margin-left: 50px;\n}\n\n.logo-login {\n  width: 121.966px;\n  height: 60.131px;\n  flex-shrink: 0;\n}\n\n.logo-Nav {\n  width: 100%;\n  height: 80px;\n  padding-left: 20px;\n}\n\n.color-a{\n  color: rgba(75, 133, 227, 0.4);\n}\n\n.color-Logout{\n  color: #005FF9;\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px; /* 137.5% */\n}\n\n.fontPageTitle{\n  font-family: Montserrat;\n  font-weight: 700;\n}\n\n.fontPageTitle600{\n  font-family: Montserrat;\n  font-weight: 600;\n}\n\n.font-size-22{\n  font-size: 22.66px;\n}\n\n.font-size-12{\n  font-size: 12px;\n}\n\n.home-title-tap {\n  width: 9.5rem;\n  font-size: 16px;\n  line-height: 19px;\n  padding: 10px;\n  margin: 10px 0 26px 0px;\n}\n\n.tap-actve{\n  border-bottom: 4px solid rgba(0, 95, 249, 1);\n}\n\n.h-logout{\n  height: 49%\n}\n\n.h-logout > a > div{\n  height: 100%\n}\n\n.card {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  margin: 10px;\n  border-radius: 10px;\n}\n\n.card-text-title-1322-400{\n  color: #111312;\n  font-family: Montserrat;\n  font-size: 13.22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 17.942px; /* 135.714% */\n}\n\n.card-text-footer-1322-400{\n  color: #AAA;\n  font-family: Montserrat;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 19px; /* 158.333% */\n}\n\n.card-color-1{\n  background: rgba(217, 243, 255, 1);\n}\n\n.card-background-icon-degradation{\n  background: linear-gradient(50.6deg, rgba(0, 95, 249, 0.1) 2.95%, rgba(179, 99, 254, 0.1) 46.88%, rgba(143, 219, 255, 0.1) 97.72%);\n}\n\n.card-color-icon-degradation{\n  mix-blend-mode: color-burn;\n  background: linear-gradient(50.6deg, #005FF9 2.95%, #B363FE 46.88%, #8FDBFF 97.72%), linear-gradient(0deg, #FFFFFF, #FFFFFF);\n  color: #000;\n  opacity: 0.5;\n  border-radius: 20px;\n}\n\n.card-color-2{\n  background: rgba(246, 240, 255, 1);\n}\n\n.card-body{\n  padding: 16px 10px 10px 10px;\n}\n\n.card:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.card-footer {\n  padding: 4px;\n}\n\n.badge {\n  padding: 5px 20px 5px 20px;\n  text-align: center;\n  border-radius: 50px;\n}\n\n.bg-color-cancelled{\n  background: #FFABAB;\n  color: rgba(254, 44, 44, 0.80);\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.bg-color-error{\n  background: #FFABAB;\n  color: #A30808;\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.bg-color-failed{\n  background: #FFABAB;\n  color: #A30808;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.bg-color-rejected{\n  background: #FFABAB;\n  color: #A30808;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.bg-color-completed{\n  background: rgba(6, 118, 71, 0.10);\n  color: #067647;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.56px;\n}\n\n.bg-color-aproved{\n  background: #C7F6E2;\n  color: #237253;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.56px;\n}\n\n.bg-color-approved{\n  background: #C7F6E2;\n  color: #237253;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.56px;\n}\n\n.bg-color-active{\n  background: #C7F6E2;\n  color: #237253;\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.56px;\n}\n\n.bg-color-pending{\n  background: #ECECEC;\n  color: #424242;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.bg-color-processed{\n  background: rgba(6, 118, 71, 0.10);\n  color: #067647;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.bg-color-expired{\n  background: #FFD8AB;\n  color: #E59500;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.btn-active{\n  background: #005FF9;\n  color: #fff;\n}\n\n.icon-blue{\n  color: #005FF9;\n}\n\n.btn-disabled {\n  background: #005ff99e;\n  color: #fff;\n}\n\n.btn-inactive{\n  background: #EDEDED;\n  \n}\n\n.btn-i{\n  padding: 2px 12px 2px 12px;\n  border-radius: 17px;\n  width: 4.5rem;\n  height: 36px;\n}\n\n.section-filters{\n  width: 94%;\n  margin: 0 0 0 24px;\n}\n\n.active{\n  background: #B363FE;\n  color: #fff;\n}\n\n.page-item{\n  padding: 4px 12px 4px 12px;\n  border-radius: 5px;\n  border: 1px solid #D0D5DD;\n  margin: 20px 2px 0 2px;\n}\n\n.page-item-1{\n  padding: 4px 12px 4px 12px;\n  border-radius: 5px;\n  margin: 20px 2px 0 2px;\n}\n\n.pages-lat{\n  margin: 25px 2px 0 2px;\n  padding: 4px 12px 4px 12px;\n}\n\n.text-w-rigth{\n  text-align: -webkit-right;\n}\n\n.input-search{\n  border: 1px solid #DADADA;\n  padding: 12px 0px 12px 24px;\n  border-radius: 24px;\n}\n\n.input-search:focus{\n  outline: none;\n  border: 1px solid #DADADA;\n}\n\n.input-text{\n  border: 1px solid #DADADA;\n  border-radius: 4px;\n}\n\n.input-text:focus{\n  outline: none;\n  border: 1px solid #DADADA;\n}\n\n.bg-bages-green{\n  background: #008000;\n  color: #fff;\n}\n\n.btn-alert-modal{\n  background: linear-gradient(0deg, #DADADA, #DADADA),\n  linear-gradient(0deg, #FFFFFF, #FFFFFF);  \n  border: 1px solid rgba(218, 218, 218, 1);\n  box-shadow: 0px 1px 2px 0px #0000000D;\n\n}\n\n.color-alert{\n  color: #E00748;\n}\n\n.btn-report{\n  border-radius: 42px;\n  border: 1px solid #DADADA;\n  background: #FFF;\n  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.08);\n  display: inline-flex;\n  height: 40px;\n  padding: 12px 20px;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n  color: #E00748;\n  font-family: Montserrat;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px; /* 183.333% */ \n}\n\n.color-alert-report{\n  color: #FF0000;\n  border: 1px solid #FF0000;\n  border-radius: 24px;\n  box-shadow: 0px 1px 2px 0px #0000000D;\n\n}\n\n.color-black{\n  color: #000;\n\n}\n\n.color-card-footer{\n  color: #AAAAAA;\n}\n\n.btn-downl{\n  padding: 8px 12px 8px 12px;\n  border-radius: 39px;\n  gap: 8px;\n  \n}\n\n.card-bages{\n  padding: 2px 8px 2px 8px;\n}\n\n.input-select{\n  width: 154px;\n  height: 40px;\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #DADADA;\n\n}\n\n.snackbar {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 12px 24px;\n  border-radius: 4px;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;\n}\n\n.snackbar.show {\n  opacity: 1;\n  visibility: visible;\n}\n\n.alert-error-snackbar{\n  background-color: rgb(238, 68, 68);\n  color: #FFFFFF;\n}\n\n.pages-title-t {\n  color: #111312;\n  font-family: 'Montserrat', sans-serif;;\n  \n  font-size: 32px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px; \n}\n\n.cargGen-amount{\n  color: #111312;\n  font-family: Montserrat;\n  font-size: 22.663px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 31.162px; \n}\n\n#table-content > thead > tr > th {\n\n}\n\n#table-content > tbody > tr > td {\n  color: #111312;\n  font-family: Montserrat;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19.853px; /* 124.079% */\n}\n\n#table-content-2 > thead > tr > th {\n\n}\n\n.header-user{\n  color: #005FF9 !important;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px; /* 135.714% */\n}\n\n.login-welcome{\n  color: var(--black, #000);\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 48px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 120%; /* 57.6px */\n}\n\n.login-welcome-sub{\n  color: var(--black, #000);\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 24px */\n}\n\n.login-section-img{\n  position: absolute;\n  top: 20px;\n}\n\n.login-input{\n  border-radius: 24px;\n  background: #FFF;\n  box-shadow: 1px 3px 10px 0px rgba(68, 68, 68, 0.17);\n}\n.login-input:focus-visible {\n  border: 1px solid #005FF9;\n  outline: none;\n}\n\n.login-laabel-pass{\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%;\n  cursor: pointer;\n}\n\n.login-Label{\n  color: var(--black, #000);\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 24px */\n}\n\n.login-btn-text{\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%; /* 24px */\n}\n\n.login-sign-in-btn{\n  color: #005FF9;\n  border-radius: 40px;\n  border: 1px solid #005FF9;\n}\n\n.border-col {\n  border: 1px solid #DADADA;\n}\n\n.errors-msm{\n  color: #F00;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%; /* 24px */\n}\n\n.errors-input{\n  border: 1px solid #F00;\n  color: #F00;\n}\n\n.errors-input:focus-visible {\n  border: 1px solid #F00;\n  color: #F00;\n  outline: none;\n}\n\n#default-search:focus-visible {\n  border: 1px solid #FFF;\n  color: #000;\n  outline: none;\n}\n\n.errors-input:focus{\n  border: 1px solid #F00;\n  color: #F00;\n}\n\n.login-changePass{\n  border-radius: 12px;\n  background: #C3FFC6;\n  padding: 16px 24px;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n}\n\n.text-12{\n  color: #666766;\n  font-family: Montserrat;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px; /* 183.333% */\n}\n\n.text-12-not-bold{\n  color: #111312;\n  font-family: Montserrat;\n  /* font-size: 12px; */\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px; /* 183.333% */\n}\n\n.text-16{\n  color: #000;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 27px; /* 168.75% */\n}\n\n.text-16-lh-normal{\n  color: #000;\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.text-13-500{\n  color: rgba(0, 0, 0, 0.60);\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.text-15-500{\n  color: rgba(0, 0, 0, 0.40);\n  font-family: Montserrat;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 19px; /* 126.667% */\n}\n\n.text-16-400{\n  color: var(--black, #000);\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 24px */\n}\n\n.text-16-500{\n  color: var(--black, #000);\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%; /* 24px */\n}\n\n.text-16-700{\n  color: rgba(0, 0, 0, 0.50);\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px; /* 137.5% */\n}\n\n.text-16-700-111312{\n  color: #111312;\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px; /* 137.5% */\n}\n\n.text-17-700{\n  color: #000;\n  font-family: Montserrat;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 27px; /* 158.824% */\n}\n\n.text-17-500{\n  color: rgba(0, 0, 0, 0.40);\n  font-family: Montserrat;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px; /* 129.412% */\n  letter-spacing: -0.408px;\n}\n\n.text-17-500-000{\n  color: #000;\n  font-family: Montserrat;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px; /* 129.412% */\n  letter-spacing: -0.408px;\n}\n\n.text-20-700{\n  color: #000;\n  font-family: Montserrat;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 27px; /* 135% */\n}\n\n.text-14{\n  color: #666766;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px; /* 157.143% */\n}\n\n.text-14-lh20{\n  color: #666766;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px; /* 157.143% */\n}\n\n\n.text-14-111312-700{\n  color: #111312;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px; /* 157.143% */ \n}\n\n.text-14-500{\n  color: #666766;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px; /* 157.143% */\n}\n\n.text-14-500-000{\n  color: #000;\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px; /* 157.143% */\n}\n\n.text-14-400-000{\n  color: #111312;\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px; /* 183.333% */\n}\n\n.text-14-600{\n  color: #666766;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 120%;\n}\n\n.text-18-500{\n  color: #111312;\n  font-family: Montserrat;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 19px; /* 105.556% */\n}\n\n.text-18-600{\n  color: #000;\n  font-family: Montserrat;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 19px; /* 105.556% */\n}\n\n.text-12634-700{\n  color: #949494;\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 12.634px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 18.048px; /* 142.857% */\n}\n\n.text-max-center{\n  text-align: -moz-center !important;\n}\n\n.text-left-impot{\n  text-align: left !important;\n}\n.table-info{\n  overflow-y: scroll;\n  scrollbar-width: thin;\n  scrollbar-color: #fff #fff;\n}\n.table-info::-webkit-scrollbar {\n  width: 6px;\n}\n.table-info::-webkit-scrollbar-track {\n  background-color: #fff;\n}\n .table-info::-webkit-scrollbar-thumb:hover {\n  background: #ededed7d\n} \n\n.table-info-role{\n  overflow: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #fff #F9F9FC;\n}\n.table-info-role::-webkit-scrollbar {\n  width: 6px;\n}\n.table-info-role::-webkit-scrollbar-track {\n  background-color: #ededed7d;\n}\n .table-info-role::-webkit-scrollbar-thumb:hover {\n  background: #f0f0f0\n} \n\n.nav-content{\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #fff #fff;\n}\n.nav-content::-webkit-scrollbar {\n  width: 6px;\n}\n.nav-content::-webkit-scrollbar-track {\n  background-color: #fff;\n}\n .nav-content::-webkit-scrollbar-thumb:hover {\n  background: #f0f0f0\n} \n\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background-color: #fff;\n}\n \n/* Handle */\n::-webkit-scrollbar-thumb {\n  background-color: #f0f0f0;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #00000048\n}\n\n.tooltip {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltip .tooltiptext {\n  visibility: hidden;\n  width: 220px;\n  background-color: #fff;\n  color: #000;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 150%;\n  left: 50%;\n  margin-left: -60px;\n}\n\n.tooltip .tooltiptext::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 25%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #08080854 transparent transparent transparent;\n}\n\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n}\n\n\n.input-otp{\n  width: 46px !important;\n  height: 48px !important;\n  padding: 10px 14px;\n  align-items: center;\n  gap: 8px;\n  border-radius: 7px;\n  background: #FFF;\n  box-shadow: 1px 3px 10px 0px rgba(68, 68, 68, 0.17);\n  margin-right: 4px;\n}\n\n.upload-btn-wrapper {\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n}\n\n.btn-upload {\n  display: flex;\n  width: 184px;\n  padding: 14px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 40px;\n  border: 1px solid #007AFF;\n  color: #007AFF;\n  text-align: center;\n  font-feature-settings: 'case' on;\n  font-family: Montserrat;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px; /* 129.412% */\n  letter-spacing: -0.408px;\n}\n\n.bord-th-body-table {\n  border-bottom: 1px solid #EAECF0;\n  padding: 9px 0px;\n}\n\n.border-fff{\n  border: 1px solid #fff !important;\n}\n\n.btn-upload-submit {\n  display: flex;\n  width: 184px;\n  padding: 14px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 7px;\n  border: 1px solid #007AFF;\n  color: #fff;\n  background: #007AFF;\n  text-align: center;\n  font-feature-settings: 'case' on;\n  font-family: Montserrat;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px; /* 129.412% */\n  letter-spacing: -0.408px;\n}\n\n.upload-btn-wrapper input[type=file] {\n  font-size: 100px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n}\n\n.file-selected{\n  display: flex;\n  padding: 8px 16px;\n  align-items: center;\n  gap: 8px;\n  border-radius: 43px;\n  background: #D4FFD9;\n}\n\n.border-input {\n  border-radius: 20px;\n  border: 1px solid var(--gray-300, #D0D5DD);\n  background: var(--white, #FFF);\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n\n.border-input-fff {\n  border-radius: 20px;\n  border: 1px solid #FFF;\n  background: var(--white, #FFF);\n  box-shadow: 0px 1px 2px 0px #FFF;\n}\n\n.table-tr-body{\n  border-radius: 20px !important;\n}\n\n.table-td-content{\n  background: #FFF;\n /*  height: 110px;  */\n}\n\n.table-border-head{\n  border-bottom: 1px solid #DADADA;\n}\n\n.statue-md{\n  border-radius: 20px;\n  border: 4px solid var(--gray-300, #D0D5DD47);\n  background: var(--white, #FFF);\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n\n.p-none{\n  display: none;\n}\n\n.profile-active{\n  border-radius: 4px;\n  border: 1px solid #005FF9;\n}\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-content {\n  position: absolute;\n  background-color: #fff;\n  min-width: 160px;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n  z-index: 1;\n  margin-top: 14px;\n}\n\n.dropdown-container-div{\n  padding: 10px 14px; \n}\n\n.dropdown-option-color:hover{\n  background: #F9F9FC; \n}\n\n.dropdown-active{\n  background: #F9F9FC; \n}\n\n.dropdown:hover .dropdown-content {\n  /* display: block; */\n}\n\n.dropdown-text-option{\n  color: var(--gray-900, #101828);\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 150% */\n}\n\n\n.color-date-000{\n  color: #000 !important;\n  background: #D0D5DD47 !important;\n  margin: 2px !important;\n  border-radius: 8px !important; \n}\n\n.color-date-949494{\n  color: #b9b7b7 !important;\n}\n\n.color-date-selected-fff{\n  color: #fff !important;\n  background: #005FF9 !important;\n}\n\n.bg-dateClean{\n  padding: 8px 16px !important;\n  background: #fff !important;\n  color: #005FF9 !important;\n  font-family: Montserrat !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  border: 1px solid #005FF9 !important;\n}\n\n.bg-today{\n  padding: 8px 16px !important; \n  background: #005FF9 !important;\n  color: #fff !important;\n  font-family: Montserrat !important;\n  font-size: 14px !important;\n  font-style: normal !important;\n  font-weight: 500 !important; \n}\n\n.text-start-import{\n  text-align: start !important;\n}\n\n.alert-success{\n  border-left: 8px solid #5BDB1F;\n  border-top: 1px solid #5BDB1F;\n  border-bottom: 1px solid #5BDB1F;\n  border-right: 1px solid #5BDB1F;\n  background: #F1FFF5;\n}\n\n.p-transaction{\n  padding: 10px 0px 0px 20px;\n}\n\n.btn-sanddbox{\n  position: relative;\n    top: -25px;\n  border-radius: 20px;\n  background: #005FF9;\n  padding: 4px 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  color: #FFF;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px; /* 135.714% */\n}\n\n.b-top{\n  border-top: solid #DADADA;\n  padding-left: 36px;\n  padding-top: 10px;\n}\n\n.bg-status-approved{\n  background-color: #18B8B8;\n  border-color: #18B8B8\n}\n\n.bg-status-pending{\n  background-color: #E9BB1A;\n  border-color:#E9BB1A ;\n}\n\n.bg-status-failed{\n  background-color: #A30808;\n  border-color: #A30808;\n}\n\n.border-status-approved{\n  border-color: #18B8B8\n}\n\n.border-status-pending{\n  border-color:#E9BB1A ;\n}\n\n.border-status-failed{\n  border-color: #A30808;\n}\n\n.text-status-approved{\n  color: #18B8B8\n}\n\n.text-status-pending{\n  color:#E9BB1A ;\n}\n\n.text-status-failed{\n  color: #A30808;\n}\n\n.css-wmw4vi-ReactDropdownSelect {\n  box-sizing: border-box;\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  border: 1px solid #fff !important; \n  width: 100%;\n  border-radius: 2px;\n  padding: 0px 0px !important;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  direction: ltr;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  cursor: pointer;\n  min-height: 36px;\n  pointer-events: all;\n}\n\n.css-wmw4vi-ReactDropdownSelect:focus, \n.css-wmw4vi-ReactDropdownSelect:focus-within {\n  outline: 0;\n  box-shadow: 0 0 0 3px rgb(252, 252, 253) !important;\n}\n\n@media screen and (min-width: 1200px) {\n  /* Estilos para la resolución de pantalla de 1440px o más */\n/*   body{\n    background-color: black;\n  } */\n}\n\n@media screen and (max-width: 1109px) {\n  /* Estilos para la resolución de pantalla de 1440px o más */\n/*    body{\n    background-color: #fff;\n  } \n  .grid-cols-layout-sm{\n    grid-template-columns: 30px 1fr;\n  }\n  \n  .grid-cols-layout-md{\n    grid-template-columns: 50px 1fr;\n  }\n  \n  .link-action-mq{\n    display: none;\n  }\n\n  .ml-mq-0{\n    margin-left: 0px;\n  } */\n\n}\n\n@media screen and (max-width: 992px) {\n  /* Estilos para la resolución de pantalla de 1440px o más */\n/*   body{\n    background-color: yellow;\n  } */\n}\n\n@media screen and (max-width: 840px) {\n  /* Estilos para la resolución de pantalla de 840px o más */\n  .login-res{\n    display: none;\n  }\n\n/*   body{\n    background-color: red;\n  } */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
